import React, { useState } from 'react';
import {
  Box,
  Button,
  Step,
  StepLabel,
  Stepper,
  Typography,
  Paper
} from '@mui/material';
import { CheckCircleOutline, RadioButtonUnchecked } from '@mui/icons-material'; // Dodajemo moderne ikone
import { useTranslation } from 'react-i18next'; // Importuj hook za prevod
import ChooseSchoolForReview from './reviewProgress/chooseSchoolForReview';
import SchoolsWithWorks from './connectionWork/SchoolForConnectTable';
import { useLocation } from 'react-router-dom';
import ReviewBySchoolPage from './checkReviewSchool/ReviewSchoolsPage';

const steps = [
  'Povezivanje radova',
  'Pregledanje u toku',
  'Provera pregledanja'
];

const StepContent = ({ step }) => {
  switch (step) {
    case 0:
      return <FirstStepConnecting />;
    case 1:
      return <SecondStepReview />;
    case 2:
      return <ThirdStepReview />;
    default:
      return null;
  }
};

const FirstStepConnecting = () => {
  return (
    <Paper
      elevation={3}
      style={{
        padding: '20px',
        borderRadius: '16px',
        backgroundColor: '#e3f2fd',
        marginTop: '20px',
        fontFamily: 'Roboto, sans-serif'
      }}
    >
      <SchoolsWithWorks />
    </Paper>
  );
};

const SecondStepReview = () => {
  return (
    <Paper
      elevation={3}
      style={{
        padding: '30px',
        borderRadius: '16px',
        backgroundColor: '#e3f2fd',
        marginTop: '20px',
        fontFamily: 'Roboto, sans-serif'
      }}
    >
      <ChooseSchoolForReview />
    </Paper>
  );
};

const ThirdStepReview = () => {
  return (
    <Paper
      elevation={3}
      style={{
        padding: '30px',
        borderRadius: '16px',
        backgroundColor: '#e3f2fd',
        marginTop: '20px',
        fontFamily: 'Roboto, sans-serif'
      }}
    >
      {/* <ReviewPage /> */}
      <ReviewBySchoolPage />
    </Paper>
  );
};

const StepperComponent = () => {
  const { t } = useTranslation(); // Hook za prevod

  const location = useLocation();

  // Izvlačimo parametar "step" iz URL-a
  const queryParams = new URLSearchParams(location.search);
  const initialStep = parseInt(queryParams.get('step')) || 0;
  const [activeStep, setActiveStep] = useState(initialStep);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const handleStepClick = (index) => {
    setActiveStep(index);
  };

  return (
    <Paper
      elevation={3}
      sx={{
        padding: '30px',
        borderRadius: '16px',
        backgroundColor: '#ffffff',
        marginTop: '20px',
        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
        minHeight: '300px',
        height: 'auto',
        transition: 'height 0.3s ease',
        boxSizing: 'border-box'
      }}
    >
      <Box sx={{ width: '100%', padding: '10px' }}>
        <Stepper
          activeStep={activeStep}
          alternativeLabel
          sx={{
            backgroundColor: 'transparent',
            padding: '10px 0', // Smanjen padding
            '& .MuiStepConnector-root': {
              height: '4px',
              borderColor: '#0d47a1'
            }
          }}
        >
          {steps.map((label, index) => (
            <Step key={label}>
              <StepLabel
                StepIconComponent={() =>
                  activeStep === index ? (
                    <CheckCircleOutline
                      style={{
                        color: '#0d47a1',
                        fontSize: '30px',
                        cursor: 'pointer'
                      }}
                      onClick={() => handleStepClick(index)} // Omogućeno klikanje na kružić
                    />
                  ) : (
                    <RadioButtonUnchecked
                      style={{
                        color: '#ccc',
                        fontSize: '30px',
                        cursor: 'pointer'
                      }}
                      onClick={() => handleStepClick(index)} // Omogućeno klikanje na kružić
                    />
                  )
                }
              >
                <Typography
                  variant="body1"
                  style={{
                    color: activeStep === index ? '#0d47a1' : '#666',
                    fontWeight: activeStep === index ? 'bold' : 'normal',
                    fontSize: '16px'
                  }}
                >
                  {t(`review.${label}`)}
                </Typography>
              </StepLabel>
            </Step>
          ))}
        </Stepper>

        {/* Dugmad */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            marginBottom: '10px'
          }}
        >
          <Button
            color="inherit"
            disabled={activeStep === 0}
            onClick={handleBack}
            sx={{
              mr: 1,
              color: '#0d47a1',
              textTransform: 'none',
              fontWeight: 'bold',
              fontSize: '14px',
              border: activeStep === 0 ? 'none' : '2px solid #0d47a1', // Ispravno korišćenje ternarnog operatora
              padding: '5px 20px', // Smanji padding
              borderRadius: '25px', // Zaobljeni rubovi
              '&:hover': {
                backgroundColor: '#e3f2fd' // Hover efekat za back dugme
              }
            }}
          >
            {t('review.back')}
          </Button>
          <Box sx={{ flex: '1 1 auto' }} />
          <Button
            onClick={handleNext}
            variant="contained"
            sx={{
              backgroundColor: '#4cceac',
              color: '#fff',
              textTransform: 'none',
              fontWeight: 'bold',
              fontSize: '14px',
              padding: '5px 20px', // Smanjen padding
              borderRadius: '25px', // Zaobljeni rubovi
              transition: 'background-color 0.3s ease',
              '&:hover': {
                backgroundColor: '#0c3d91' // Hover efekat za next dugme
              }
            }}
          >
            {activeStep === steps.length - 1
              ? t('review.finish')
              : t('review.next')}
          </Button>
        </Box>

        {/* Sadržaj */}
        <Box sx={{ marginTop: '20px' }}>
          {activeStep === steps.length ? (
            <Box>
              <Typography sx={{ mb: 2 }}>
                {t('review.all_steps_complete')}
              </Typography>
              <Button
                onClick={handleReset}
                variant="contained"
                sx={{
                  backgroundColor: '#0d47a1',
                  color: '#fff',
                  textTransform: 'none',
                  fontWeight: 'bold',
                  borderRadius: '25px', // Zaobljeni rubovi
                  '&:hover': {
                    backgroundColor: '#0c3d91'
                  }
                }}
              >
                {t('review.reset')}
              </Button>
            </Box>
          ) : (
            <Box>
              <StepContent step={activeStep} />
            </Box>
          )}
        </Box>
      </Box>
    </Paper>
  );
};

export default StepperComponent;
